module.exports = __webpack_public_path__ + "img/Dashboard-1.6ed23f50.svg";